import type { ChatMessageListResponsePageAllOfThreeContentItem } from './chatMessageListResponsePageAllOfThreeContentItem';

export type ChatMessageListResponsePageAllOfThree = {
  /** 채팅 메시지 목록 */
  content?: ChatMessageListResponsePageAllOfThreeContentItem[];
};
